<template>
  <section class="start-today">
    <div class="container start-inner">
      <div class="start-text wow slideInLeft">
        <h2>Začni dnes</h2>
        <p>
          Bez ohľadu na vašu aktuálnu úroveň kondície, naši skúsení tréneri
          vám pomôžu vytvoriť plán, ktorý je prispôsobený vašim potrebám.
          Začnite teraz a zmeňte svoj život k lepšiemu!
        </p>
        <a href="#contact" class="cta-btn">Kontaktujte nás</a>
      </div>
      <div class="start-img wow slideInRight">
        <img src="@/assets/images/diamond_horne_poschodie3.jpg" alt="Začni dnes" />
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "StartTodaySection",
}
</script>

<style scoped>
.start-today {
  background: linear-gradient(135deg, #E8B923 0%, #d4a61e 100%);
  color: #000;
  padding: 80px 0;
}

.start-inner {
  display: flex;
  gap: 48px;
  align-items: center;
}

.start-text {
  flex: 1;
}

.start-text h2 {
  font-size: clamp(26px, 4vw, 40px);
  margin-bottom: 18px;
  color: #000;
}

.start-text h2::after {
  content: '';
  display: block;
  width: 48px;
  height: 3px;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 2px;
  margin-top: 10px;
}

.start-text p {
  font-size: 16px;
  line-height: 1.75;
  color: rgba(0, 0, 0, 0.75);
  margin-bottom: 28px;
}

.cta-btn {
  display: inline-block;
  padding: 14px 32px;
  background-color: #000;
  color: #E8B923;
  font-size: 15px;
  font-weight: 700;
  border-radius: 8px;
  letter-spacing: 0.04em;
  transition: background-color 0.25s ease, transform 0.2s ease, box-shadow 0.25s ease;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.cta-btn:hover {
  background-color: #111;
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.35);
}

.start-img {
  flex: 1;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
}

.start-img img {
  width: 100%;
  aspect-ratio: 4 / 3;
  object-fit: cover;
  display: block;
  transition: transform 0.4s ease;
}

.start-img:hover img {
  transform: scale(1.03);
}

@media (max-width: 860px) {
  .start-inner {
    flex-direction: column;
    gap: 28px;
  }

  .start-text,
  .start-img {
    width: 100%;
  }
}

@media (max-width: 480px) {
  .start-text {
    text-align: center;
  }

  .start-text h2::after {
    margin: 10px auto 0;
  }

  .cta-btn {
    display: block;
    text-align: center;
  }
}
</style>
